import React,{useEffect,useState,useMemo} from "react";
import {Table,Spin} from "antd";
import axios from "axios";
import {clientColumns} from "../columns/clientColumns";
import {LedgerResponsiveWrapper,denseTableProps,API_BASE,getArn} from "../LedgerResponsive";
import FolioTable from "./FolioTable";
import ReportOptionsModal from "../modals/ReportOptionsModal";

export default function ClientTable({searchQuery,onOpenModal,onOpenFolioModal,onOpenSchemeModal,onOpenTxnModal}){
 const [clients,setClients]=useState([]),[loading,setLoading]=useState(false),[reportClient,setReportClient]=useState(null);
 useEffect(()=>{setLoading(true);axios.get(`${API_BASE}/get_clients.php?arn_no=${getArn()}`)
 .then(r=>setClients(r.data.clients||[])).catch(()=>setClients([])).finally(()=>setLoading(false));},[]);
 const filtered=useMemo(()=>!searchQuery?clients:clients.filter(c=>[c.invester_name,c.pan,c.email,c.mobile]
 .some(v=>(v||"").toLowerCase().includes(searchQuery.toLowerCase()))),[clients,searchQuery]);
 return <><LedgerResponsiveWrapper>{loading?<Spin/>:<Table
 columns={clientColumns(onOpenModal,setReportClient)} dataSource={filtered} rowKey="pan" {...denseTableProps}
 expandable={{expandedRowRender:(record)=><FolioTable pan={record.pan} onOpenModal={onOpenFolioModal}
 onOpenSchemeModal={onOpenSchemeModal} onOpenTxnModal={onOpenTxnModal}/>}}/>}</LedgerResponsiveWrapper>
 <ReportOptionsModal open={!!reportClient} client={reportClient} onClose={()=>setReportClient(null)}/></>;
}
